import * as Actions from "store/actions/app/banks.actions"

const initialState = {
  loading_banks: false,
  banks: [],

  loading_bank_account_types: false,
  bank_account_types: [],
}

const banksReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_BANKS: {
      return {
        ...state,
        loading_banks: action.payload.loading ?? state.loading_banks,
        banks: action.payload.data ?? state.banks,
      }
    }
    case Actions.GET_BANK_ACCOUNT_TYPES: {
      return {
        ...state,
        loading_bank_account_types: action.payload.loading ?? state.loading_bank_account_types,
        bank_account_types: action.payload.data ?? state.bank_account_types,
      }
    }
    default: {
      return state
    }
  }
}

export default banksReducer
